import type { User } from '@/api/types'

export function isAdmin(user?: User | null): boolean {
  if (!user) return false
  return user.role === 'Admin' || user.role === 'SuperAdmin'
}

export function isAdminRole(role: string): boolean {
  return role === 'Admin' || role === 'SuperAdmin'
}

export function canManageUser(current?: User | null): boolean {
  return isAdmin(current)
}
